import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import CheckOkButton from './CheckOkButton';
import CheckNoneButton from './CheckNoneButton';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose();

const button = enhance(({ handleAction, checked }) => {
  return (
    <div>
      {checked ? (
        <CheckOkButton
          onClickAction={() => {
            handleAction();
          }}
        />
      ) : (
        <CheckNoneButton
          onClickAction={() => {
            handleAction();
          }}
        />
      )}
    </div>
  );
});

export default withStyles(styles)(button);
